import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { IError } from '@/types/components/error';

const initialState: IError = {
    errorFields:  {},
    isValidAPIKey: false,
    isValidRoutesAPIKey: false
};

const errorSlice = createSlice({
    name: 'error',
    initialState,
    reducers: {
        handleSetErrorFields(state, action: PayloadAction<Partial<IError>>) {
            return {
                ...state,
                ...action.payload,
                errorFields: {
                    ...state.errorFields,
                    ...action.payload.errorFields
                },
            };
        },
        handleResetErrorFields(state) {
            return {
                ...state,
                errorFields: {},
            };
        }
        
    },
});

export const errorFieldsSelector = createSelector((state: RootState) => state.error, (state) => state);

export const { handleSetErrorFields, handleResetErrorFields } = errorSlice.actions

export default errorSlice